import { ComponentProps, createElement, FC, SVGProps, useContext } from 'react'
import { config, styled } from '../../../config/stitches'
import { AlertContext } from '../AlertContext'

const Root = styled('span', {
  height: '20px',
  width: '20px',
  flexShrink: 0,
  marginRight: '8px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
})

interface Props {
  iconOverride?: React.FC<SVGProps<SVGSVGElement>>
}

export const AlertIcon: FC<ComponentProps<typeof Root> & Props> = ({
  iconOverride,
  css,
  ...rest
}) => {
  const { colorScheme } = useContext(AlertContext)

  const icon = iconOverride || colorScheme.icon

  return (
    <Root css={{ color: config.theme.colors[colorScheme.textColor], ...css }} {...rest}>
      {createElement(icon, { height: '100%', width: '100%' })}
    </Root>
  )
}
